<template>
  <a :href="url">
    <div class="card">
    <el-card :body-style="{ padding: '0px' }">
      <img
          :src="coverUrl"
          class="cover"

      />
      <div style="padding: 14px">
        <h2 class="title">{{title}}</h2>
        <span class="intro">{{intro}}</span>
      </div>
    </el-card>
    </div>
  </a>
</template>

<script>
export default {
  name: "fabric_2",
  data() {
    return {
      title: "区块链应用开发？来看Fabric测试网络启动流程! ",
      intro: "我们开始解析network.sh的脚本内容",
      url: "posts/fabric_2.html",
      coverUrl: "img/fabric_cover_2.png"
    }
  }
}
</script>

<style scoped>
a {
  margin-top: 5%;
  display: block;
}

.card :hover {
  overflow: visible;
  transform: scale(1.1);
  transition: all 0.6s;
}
img{
  width: 100%;

}
.cover{
}
.title{
  color: #303133;
  font-size: small;

}
.intro{
  color: #909399;
  margin-left: 3%;
  font-size: smaller;

}
.el-card{
  height:300px;
  width: 250px;
}
</style>